import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "antd";
import { ColumnInterface } from "../../../../interfaces/table/column.interface";
import { IAlunoTable } from "../../interfaces/aluno-table.interface";
import StatusMatricula from "../StatusMatricula";
import { formatDateToPattern } from "../../../../util/format-date.util";

interface UseAlunoTableColumnsParams {
  onOpenAlunoModal: (item: IAlunoTable) => void;
}

export const useAlunoTableColumns = ({
  onOpenAlunoModal,
}: UseAlunoTableColumnsParams): ColumnInterface<IAlunoTable>[] => {
  const { t } = useTranslation(["gestao_de_aulas"]);

  return [
    {
      key: 'nome',
      title: t('gestao_de_aulas:studentName'),
      render: ({ nome, statusMatricula }) => (
        <div className="aluno-table__aluno-cell">
          <p className="aluno-cell__aluno-nome">{nome}</p>
          <StatusMatricula codigoStatusMatricula={statusMatricula} />
        </div>
      ),
    },
    {
      key: 'codigo',
      title: t('gestao_de_aulas:code'),
      render: (item) => (
        <Tooltip title={t("gestao_de_aulas:studentModal.tooltip")}>
          <Button
            type="link"
            className="aluno-table__code-link"
            onClick={() => onOpenAlunoModal(item)}
          >
            {item?.codigo ?? "-"}
          </Button>
        </Tooltip>
      ),
    },
    {
      key: "dataInicioContrato",
      title: t("gestao_de_aulas:contractStart"),
      render: (item) =>
        item?.dataInicioContrato
          ? formatDateToPattern(item.dataInicioContrato)
          : "-",
    },
    {
      key: "dataFimContrato",
      title: t("gestao_de_aulas:contractEnd"),
      render: (item) =>
        item?.dataFimContrato
          ? formatDateToPattern(item.dataFimContrato)
          : "-",
    },
    {
      key: 'matricula',
      title: t('gestao_de_aulas:enrollment'),
    },
    {
      key: "idFinanceiro",
      title: t("gestao_de_aulas:financial"),
      render: (item) => (item?.idFinanceiro ? `#${item.idFinanceiro}` : "-"),
    },
    {
      key: 'frequencias',
      title: t('gestao_de_aulas:absences'),
      render: (item) => item?.quantidadeDeFaltas,
    },
  ];
};

